<template>
    <div :class="{result:!isMobile,mResult:isMobile}">
        <div class="cont">
            <img
                class="icon"
                :src="require('@/assets/img/result-true.svg')"
                alt
            />
            <!-- <p class="font14 bold">Paiement réalisé avec succès</p> -->
            <p class="SubTitle">{{ langPage['v4-registersuccess']['TXT_mercipourvotreins'] }}</p>
            <p
                class="tips font14"
            >{{ langPage['v4-registersuccess']['TXT_nousreviendrons'] }}</p>
            <!-- <div class="type2" v-if="type==2">
              <p
                class="tips font14"
              >Votre demande de virement a bien été enregistrée. Le détail de la commande et les informations bancaires ont été envoyés à l’adresse: simon@efashion-paris.com</p>
              <p class="tips font14 bold">Attention: la marchandise ne sera bloquée et préparée qu’à réception de la preuve de virement.</p>
              <p class="tips font14">L’expédition sera programmée à compter de la date de réception du virement. Pour toute information et/ou conseil, vous pouvez nous contacter par téléphone au +33 1 53 27 91 08 ou par mail au service@efashion-paris.com </p>
            </div> -->
            <!-- <p class="tips font14">Votre paiement a été refusé pour les raisons suivantes: 3D secure n’a pas été accepté, votre crédit a été dépassé ou insufisant.</p> -->
            <button class="black" @click="toBack(1)">{{ langPage['404']['TXT_retouracceuil'] }}</button>
            <!-- <button class="border">Retour à l’accueil</button> -->
            <!-- 背景部分 -->
            <img class="bgleft" src="@/assets/img/Cercle2.svg" alt/>
            <img class="bgright" src="@/assets/img/Cercle1.svg" alt/>
            <img class="line" src="@/assets/img/Trait2.svg" alt/>
        </div>
    </div>
</template>
<script>
// import
import {mapState} from "vuex";

export default {
    name: "result",

    data() {
        return {
            type: this.$route.query.type,
            isMobile: this.$store.state.isMobile,
            titleList: [
                "Merci pour votre commande",
                "Demande de paiement par virement",
                "Votre paiement a été refusé."
            ]
        };
    },
    mounted() {
    },
    computed: {
        langPage() {
            return this.$store.state['langPage']
        }
    },
    methods: {
        toBack() {
            this.$router.replace({name: 'home'})
        }
    }
};
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Checkout/registerSuccess.less">
</style>
